import { render, staticRenderFns } from "./PropertiesSearch2024.vue?vue&type=template&id=05888aea"
import script from "./PropertiesSearch2024.vue?vue&type=script&lang=js"
export * from "./PropertiesSearch2024.vue?vue&type=script&lang=js"
import style0 from "./PropertiesSearch2024.vue?vue&type=style&index=0&id=05888aea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports